import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useEventQuestions(eventId, { filter, sortBy: sortFunction } = {}) {
    const selector = useCallback((state) => state.events[eventId]?.questions.listed, [eventId]),
        questions = useSelector(selector);

    return useMemo(() => {
        let result = questions ?? [];

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [questions, filter, sortFunction]);
}
